import { gql, useMutation } from '@apollo/client';

import type { DeleteVehicleMutation, DeleteVehicleMutationVariables } from './__generated__/useDeleteVehicle.gql';

const DELETE_VEHICLE = gql`
  mutation DeleteVehicle($input: DeleteVehicleInput!) {
    deleteVehicle(input: $input)
  }
`;

/**
 * Removes a family `Vehicle` by id. Used by `DependantVehicleStep` to keep the
 * persisted row count in sync with the form: when the user reduces the
 * vehicle-count select, the trailing rows are deleted on Continue. Refetches
 * `GetOnboardingVehicles` so the list query reflects the removal.
 */
export const useDeleteVehicle = () => {
  return useMutation<DeleteVehicleMutation, DeleteVehicleMutationVariables>(DELETE_VEHICLE, {
    refetchQueries: ['GetOnboardingVehicles'],
  });
};
